import { useMemo } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export function useDashboardChartLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return useMemo(() => ({
    isMobile,
    isTablet,
    heights: {
      lg: isMobile ? 300 : isTablet ? 340 : 380,
      md: isMobile ? 280 : isTablet ? 320 : 340,
      sm: isMobile ? 240 : isTablet ? 280 : 300,
    },
    margin: {
      top: 12,
      right: isMobile ? 12 : 24,
      left: isMobile ? 0 : 8,
      bottom: isMobile ? 64 : 44,
    },
    axis: {
      tick: { fontSize: isMobile ? 9 : 11 },
      x: {
        angle: isMobile ? -35 : 0,
        textAnchor: (isMobile ? 'end' : 'middle') as 'end' | 'middle',
        height: isMobile ? 58 : 34,
        interval: isMobile ? ('preserveStartEnd' as const) : (0 as const),
      },
      y: {
        width: isMobile ? 44 : 60,
      },
    },
    legend: {
      verticalAlign: 'bottom' as const,
      align: 'center' as const,
      layout: (isMobile ? 'vertical' : 'horizontal') as 'vertical' | 'horizontal',
      wrapperStyle: {
        fontSize: isMobile ? 10 : 12,
        lineHeight: 1.5,
        paddingTop: 8,
        width: '100%',
      },
    },
    pie: {
      innerRadius: isMobile ? '42%' : '55%',
      outerRadius: isMobile ? '68%' : '82%',
      cy: isMobile ? '45%' : '48%',
    },
    tooltip: {
      contentStyle: {
        borderRadius: 12,
        border: '1px solid #e2e8f0',
        fontSize: isMobile ? 11 : 12,
      },
    },
    formatDateTick: (value: string) => {
      if (!value) return value;
      if (isMobile && value.length >= 10) return value.slice(5);
      return value;
    },
  }), [isMobile, isTablet]);
}
